import api from "@opentelemetry/api";

const metricProvider = api.metrics.getMeterProvider();
export const meter = metricProvider.getMeter("nvs-swoosh-api-metrics");

// ⚠️ In Next.js - we can't really have singletons. In an effort to reduce the places where we
// use a symbol ref, we are taking the slight performance hit here by allowing this to
// be initialized multiple times that said - It's safe to call `createHistogram()` multiple times
// — OpenTelemetry deduplicates internally.

export const getHttpRequestDurationHistogram = () => {
  return meter.createHistogram("http.api.requests.duration", {
    description: "Duration of HTTP requests in milliseconds",
    unit: "ms",
  });
};
